import React, { useMemo, useState } from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import NtTouchableEffect from "./NtTouchableEffect";
import NtMaterialIcon from "./NtMaterialIcon";
import NtDevider from "./NtDevider";
import NtText from "./NtText";
import { useTheme } from "../context/ThemeContext";

function NtDropDownSelectContainer({
  containerStyle,
  data,
  title,
  selection,
  onSelect,
  placeholder = "Make a selection",
}) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  const [open, setOpen] = useState(false);

  const renderRow = (item, index, isLast) => {
    const selected = item.title === selection?.title;
    return (
      <NtTouchableEffect
        key={item.title}
        onPress={() => {
          if (onSelect) onSelect(item);
          setOpen(false);
        }}
      >
        <View style={styles.row}>
          <NtText
            style={[styles.rowText, selected && { color: theme.brand2, fontWeight: "600" }]}
            numberOfLines={1}
          >
            {item.title}
          </NtText>
          {selected ? (
            <NtMaterialIcon name="check" size={15} color={theme.brand2} />
          ) : null}
        </View>
        {!isLast ? <NtDevider /> : null}
      </NtTouchableEffect>
    );
  };

  const hasSelection = !!selection?.title;

  return (
    <div className="overlay" style={{ position: "relative", ...containerStyle }}>
      {title ? (
        <NtText style={[styles.title, { marginLeft: 4 }]}>{title}</NtText>
      ) : null}
      <NtTouchableEffect
        style={[styles.input, styles.inputRow]}
        onPress={() => setOpen(!open)}
      >
        <NtText style={{ color: hasSelection ? theme.text : theme.textMute }}>
          {selection?.title || placeholder}
        </NtText>
        <NtMaterialIcon
          name={open ? "chevron-up" : "chevron-down"}
          color={theme.textDim}
        />
      </NtTouchableEffect>
      {open && (
        <View style={styles.dropdown}>
          <ScrollView
            contentContainerStyle={{ flexGrow: 1 }}
            showsVerticalScrollIndicator={false}
          >
            {data?.map((each, index) =>
              renderRow(each, index, index === data.length - 1),
            )}
          </ScrollView>
        </View>
      )}
    </div>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    input: {
      paddingHorizontal: 10,
      height: 38,
      backgroundColor: t.surface2,
      borderWidth: 1,
      borderColor: t.borderSoft,
      borderRadius: t.radius,
    },
    inputRow: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
    title: { fontSize: 12, fontWeight: "600", color: t.textDim, marginBottom: 4 },
    row: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      paddingVertical: 9,
      paddingHorizontal: 6,
    },
    rowText: { color: t.text, fontSize: 13, flex: 1, textAlign: "left" },
    dropdown: {
      position: "absolute",
      left: 0,
      right: 0,
      top: "100%",
      zIndex: 50,
      marginTop: 6,
      backgroundColor: t.surface2,
      borderWidth: 1,
      borderColor: t.borderSoft,
      paddingHorizontal: 8,
      paddingVertical: 4,
      borderRadius: t.radius,
      maxHeight: 220,
      ...(typeof document !== "undefined"
        ? { boxShadow: "0 10px 28px -8px rgba(0,0,0,0.55)" }
        : {}),
    },
  });

export default NtDropDownSelectContainer;
